<template>
  <div class="cxm-ModalTimePicker">
    <div class="cxm-ModalTimePicker-ContentTimer">
      <div class="cxm-ModalTimePicker-ContentTime">
        <div
          v-for="hour in hours"
          :key="hour.id"
          :class="[hour.checked ? 'cxm-ModalTimePicker-TimeSelected' : '']"
          class="cxm-ModalTimePicker-Time"
          @click="getHour(hour)"
        >
          {{ hour.id }}
        </div>
      </div>
      <Divider
        :vertical="true"
        height="193px"
        class="cxm-ModalTimePicker-divider"
        spacing="0"
      />
      <div class="cxm-ModalTimePicker-ContentTime">
        <div
          v-for="minute in minutes"
          :key="minute.id"
          class="cxm-ModalTimePicker-Time"
          :class="[minute.checked ? 'cxm-ModalTimePicker-TimeSelected' : '']"
          @click="getMinute(minute)"
        >
          {{ minute.id }}
        </div>
      </div>
      <Divider
        :vertical="true"
        height="193px"
        class="cxm-ModalTimePicker-divider"
        spacing="0"
      />
      <div class="cxm-ModalTimePicker-ContentTime">
        <div
          v-for="period in periods"
          :key="period.id"
          class="cxm-ModalTimePicker-Time"
          :class="[period.checked ? 'cxm-ModalTimePicker-TimeSelected' : '']"
          @click="getPeriod(period)"
        >
          {{ period.id }}
        </div>
      </div>
    </div>
    <Divider spacing="0" />
    <div class="cxm-ModalTimePicker-Apply">
      <Button
        class="cxm-ModalTimePicker-Apply-Button"
        :handle-click="setHour"
        type="text"
        :disabled="!isSelected"
        :label="labelButton"
      />
    </div>
  </div>
</template>
<script>
import Button from '@/packages/ui/components/Button/Button.vue';
import Divider from '@/packages/ui/components/Divider/Divider.vue';

export default {
  components: { Button, Divider },
  props: {
    value: {
      type: String,
      default: '',
    },
    valueDefault: {
      type: String,
      default: '',
    },
    labelButton: {
      type: String,
      default: 'Aplicar',
    },
    newTime: {
      type: Object,
      default: () => {},
    },
    defaultValueInput: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hours: [],
      minutes: [],
      periods: [
        {
          id: 'AM',
          checked: false,
        },
        {
          id: 'PM',
          checked: false,
        },
      ],
      time: {
        hour: '',
        minute: '',
        period: '',
      },
    };
  },
  computed: {
    isSelected() {
      return !!(this.time.hour && this.time.minute && this.time.period);
    },
  },
  created() {
    this.createArrays(this.hours, 12);
    this.createArrays(this.minutes, 59);
  },
  methods: {
    getHour(value) {
      this.time.hour = value.id;
      this.changeBackground(value, this.hours);
    },
    getMinute(value) {
      this.time.minute = value.id;
      this.changeBackground(value, this.minutes);
    },
    getPeriod(value) {
      this.time.period = value.id;
      this.changeBackground(value, this.periods);
    },
    setHour() {
      const [hour, minute, period] = this.valueDefault.split(/:|\s/);
      this.time.hour = this.newTime.hour || hour;
      this.time.minute = this.newTime.minute || minute;
      this.time.period = this.newTime.period || period;
      this.setApplyTime(this.time);
    },
    setApplyTime(time) {
      this.$emit('apply', time);
    },
    changeBackground(value, array) {
      this.$emit('change', this.time);
      const indexHaveBackground = array.findIndex((hour) => hour.checked);
      if (indexHaveBackground >= 0) {
        array[indexHaveBackground].checked = false;
      }
      const indexAtual = array.findIndex((hour) => value.id == hour.id);
      array[indexAtual].checked = true;
    },
    createArrays(array, max) {
      let inicialValue;
      array == this.hours ? (inicialValue = 1) : (inicialValue = 0);
      for (let i = inicialValue; i <= max; i++) {
        array.push({
          id: i < 10 ? `0${i}` : i,
          checked: false,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cxm-ModalTimePicker {
  width: 160px;
  height: 241px;
  background-color: var(--track-color-white);
  border-radius: 4px;
  box-shadow: var(--track-shadow-sm);
  cursor: pointer;
}

.cxm-ModalTimePicker-ContentTimer {
  display: flex;
  max-height: 193px;
}

.cxm-ModalTimePicker-ContentTime {
  width: 52px;
  flex-direction: column;
  text-align: center;
  overflow-y: scroll;
}

.cxm-ModalTimePicker-divider {
  border-left: 1px solid var(--track-color-bluegray-20);
}

.cxm-ModalTimePicker-Time {
  height: var(--track-spacing-lg);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--track-color-bluegray-70);
  line-height: 22px;
  &.--timeSelected {
    background-color: var(--track-color-bluegray-10);
  }
}

.cxm-ModalTimePicker-TimeSelected {
  background-color: #334e66;
  color: var(--track-color-white);
  font-weight: var(--track-font-weight-medium);
}

.cxm-ModalTimePicker-Apply {
  height: 48px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  padding-right: var(--track-spacing-md);
}

.cxm-ModalTimePicker-Apply-Button {
  width: 48px;
  line-height: var(--track-spacing-md);
}

*::-webkit-scrollbar {
  width: 0;
}
</style>
